import React, { Component } from "react";

import giveawaySVG from '../../images/giveaway.svg';
import emailGif from '../../images/email-gif.gif';
import signupGif from '../../images/signup-gif.gif';


import './referrals.css'

class Referrals extends Component {
    render() {
      return (
			<div>
				<section id="splash-section">
					<div id="splash">
						<div class="splash-text">
							<h1>Refer a business, save S$50!</h1>
							<p>
								Know another business that wants to grow their online store? Tell them about Maesh - they get lower transaction fees, and you get S$50 in credit! 
							</p>
						</div>
						<div class="splash-image-container">
							<img class="splash-image" alt="" src={giveawaySVG}/>
						</div>
					</div>
				</section>
				<section id="steps-section">
					<div class="steps">
						<div class="step">
							<img class="step-gif" alt="" src={emailGif}/>
							<h1>Step 1</h1>
							<p>
								Tell them about Maesh and then let us know about the merchant you want to refer at <a href="mailto:hello@maesh.io?subject=Maesh Referral" rel="noreferrer" target="_blank">hello@maesh.io</a>
							</p>
						</div>
						<div class="step">
							<img class="step-gif" alt="" src={signupGif} />
							<h1>Step 2</h1>
							<p>
								The business you're referring signs up to Maesh and starts using the Maesh payment gateway and makes a transaction.
							</p>
						</div>
					</div>
					<div class="steps">
						<div class="step-full" style={{fontSize: "4rem"}}>
							<h1>You get S$50 savings on your upcoming transaction fees!*</h1>
						</div>
					</div>
					<div id="disclaimer">
						<p>
							*Terms and Conditions Apply
						</p>
					</div>
				</section>
				<section>
					<div id="terms-and-conditions">
						<div id='tc-container'>
							<h1 style={{marginBottom: "2vh" }}>
								Terms and conditions
							</h1>
							<p>
								Rewards are given out only for successful referrals. A referral is successful if: 
								<ol>
									<li>The business you're referring creates an account on <a href="https://dashboard.maesh.io/accounts/signup" rel="noreferrer" target="_blank">dashboard.maesh.io</a> </li>
									<li>They have installed the Maesh plugin/module or have integrated the Maesh libraries into their webstore </li>
									<li>The business being referred has at least one successful transaction made through Maesh</li>
									<li>You - the business that's referring - will get a cumulative S$50 in savings on your transaction fees starting from that date until the credit is fully used up</li> 
									<li>These are the current Terms & Conditions for our referral program and have last been updated on October 13, 2020. We reserve the right to modify or amend them at any time</li>
								</ol>
							</p>
						</div>
					</div>
				</section>
			</div>
      );
    }
}

export default Referrals;
